import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"application-footer-container"},[_c(VFooter,{attrs:{"app":"","padless":"","fixed":"","color":"primary"}},[_c(VRow,{attrs:{"justify":"center","no-gutters":""}},[_c(VCol,{attrs:{"cols":"12","sm":"12"}},[_c(VCard,{staticClass:"text-center",attrs:{"color":"primary","dark":""}},[_c(VCardText,[_vm._v(_vm._s(_vm.copyright))])],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }